module.exports = __webpack_public_path__ + "img/H0-600w.31b0cf2a.jpg";